<template>
<div>
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->

        <img :src="curImg.src" alt="" srcset="" style="width:100%;"  class="animate__animated animate__slideInLeft">

    </div>
    <div class="containerOne" style="position:relative;width:100%;height:910px;margin:45px 0 0 0">
      <img src="@/views/aboutUs/images/group01.png" alt="" srcset="" style="width:1458px;position:absolute;right:10px;z-index:1">
       <img v-animate-onscroll="'animate__animated animate__fadeInLeft'" src="@/views/aboutUs/images/FX.png" alt="" srcset="" style="width:1280px;position:absolute;z-index:3;left:0;top:0px">
       <div class="wordsOne" v-animate-onscroll="'animate__animated animate__fadeInRight'">
        <span>这是一场关于色彩的旅程，始于科技，终于品质。 </span>
        <span>每一件产品，从开始便具有独特的色彩属性，</span>
        <span>经过层层工序的洗礼，每一处细节都做到精准把控；</span>
        <span>科技力量的加持，让产品变得更加美观、耐用、环保。</span>
        <span>一路走来，品质始终坚若磐石。</span>
        <span>跨越千山万水，与你相遇。</span>
        <span>用我的色彩，我的品质，我的科技，</span>
        <span>给你带来与众不同的色彩视觉表现。</span>
        <span>更有全方位的呵护与体验。</span>
        <span>你好，世界。</span>
        <span>我们一起可以变得更加美好。</span>
       </div>
    </div>
    <!-- <footerComponent/> -->
    <div class="containerTwo" style="width:1460px;padding:10px 45px;margin:0 auto;margin-bottom:20px;height:600px">
      <div class="company">
        <img src="./images/bgLogo01.png" alt="" srcset="" width="100%" style="position:absolute;z-index:1;">
        <div style="width:100%;height:100%" ref="box">
          <div class="logoContain">
            <span class="logoTit" style="left:60px"><countTo ref="year" :autoplay="false" :startVal='0' :endVal='1995' :duration='3000' separator=""></countTo></span>
            <span class="logoWord" style="left:90px;"><countTo ref="year2" :autoplay="false" :startVal='0' :endVal='1995' :duration='3000' separator=""></countTo>年创立品牌</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:120px"><countTo ref="year3" :autoplay="false" :startVal='0' :endVal='28' :duration='3000' separator=""></countTo></span>
            <span class="logoWord" style="left:100px;"><countTo ref="year4" :autoplay="false" :startVal='0' :endVal='28' :duration='3000' separator=""></countTo>年品质坚若磐石</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:60px"><countTo ref="ton" :autoplay="false" :startVal='0' :endVal='4200' :duration='3000' separator=""></countTo></span>
            <span class="logoWord" style="left:90px;">年产量<countTo ref="ton2" :autoplay="false" :startVal='0' :endVal='4200' :duration='3000' separator=""></countTo>吨</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:60px"><countTo  ref="square" :startVal='0'  :autoplay="false" :endVal='26000' :duration='3000' separator=""></countTo></span>
            <span class="logoWord" style="left:80px;"><countTo  ref="square2" :startVal='0'  :autoplay="false" :endVal='26000' :duration='3000' separator=""></countTo>平花园式工业园区</span>
          </div>
          <div class="clearBoth"></div>
          
        </div>
        <div class="words">
            <span>
              优力美，一家充满热情、富有激情的国际化高新技术企业，诞生历史悠久，如今正以其独特的魅力展示着它的绚丽，犹如一枚宝石，在青岛这块美丽而富饶的土地上熠熠生辉！
            </span>
            <span>
              近二十年的风雨锤炼，优力美已经摆脱掉了青涩与稚嫩，在烟台菜阳拥有占地面积26000多平方米的花园式工业园区。目前优力美拥有专业研发团队，涉足高端粉末涂料研发与销售，在莱阳、青岛两地分别建立生产基地和运营研发中心，我们凭借强大的专业团队、高标准的质量体系、完善的管理体制，迅速在行业中发展壮大，以优质的服务、健全的销售网络，赢得广大合作伙伴的支持与信赖。
            </span>
          </div>
      </div>

    </div>
    <div>

    </div>
    <div class="climeStyle" style="height:200px">
      <span class="climeTitle">
        发展历程
      </span>
      <div style="margin:55px auto;width:1300px">
        <!-- 时间节点开始 -->
        <div class="block" style="position:absolute;z-index:99;color:#fff;width:100%;left:0">
          <div class="processBox">
            <div class="timelineProcessBox">
              <el-timeline class="timeline">
                <el-timeline-item
                  class="lineitem"
                  :class="activity.done ? 'active' : 'inactive'"
                  v-for="(activity, index) in activities"
                  :key="index"
                  :timestamp="activity.time"
                >
                  <span style="display: flex; flex-direction: column">
                    <span style="margin: 10px 0; font-size: 18px;color:#272a36;font-weight:300">
                      {{ activity.content }}
                    </span>
                  </span>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
        <!-- 时间节点结束 -->
      </div>
    </div>
    <div class="climeStyleBg"></div>
</div>
</template>
<script>
import countTo from 'vue-count-to';
// import { Swiper } from 'swiper/vue';
import { timeline ,cate } from '@/api/index.js'
const self = this
export default {
  name: 'App',
   components:{
    countTo
  },
  data() {  
    return { 
      curImg:{},
      activities : [
  {
    content: '创立品牌于莱阳',
    time: '1995',
    people: '五六七',
    done: true,
  },
  {
    content: '成立青岛公司',
    people: '吉吉国王',
    done: false,
    time: '2003',
  },
  {
    content: '成立优力美青岛总部',
    done: false,
    people: '熊大',
    time: '2017',
  },
  {
    content: '青岛运营研发中心投入使用',
    people: '',
    done: false,
    time: '2024',
  }],
      timerId:null,
      timelineData:[
        "2020荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
      ],
      jjList: [
        {message: '2017',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2018',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2019',timelineData:[
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能",
        "年度优秀"
        ]},
        {message: '2020',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2021',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能",
        ]},
        {message: '2022',timelineData:[
        "行业标兵",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2023',timelineData:[
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2024',timelineData:[
        "荣获最有价值企业",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2025',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2026',timelineData:[
        "青岛创新技术企业",
        "荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]}
      ],
    swiperOptions: {
        loop: true,
        allowTouchMove: false, 
        autoplay: {
          disableOnInteraction: false,
          delay: 2500
        },
        slidesPerView: 7, // 显示个数
        spaceBetween: 10,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        on: {  
          slideChange: function () {  
            let jjList =[
              {message: '2017',timelineData:[
              "2017荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2018',timelineData:[
              "2018荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2019',timelineData:[
              "2019荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2020',timelineData:[
              "2020荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2021',timelineData:[
              "2021荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2022',timelineData:[
              "2022行业标兵",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2023',timelineData:[
              "2023荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2024',timelineData:[
              "2024荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2025',timelineData:[
              "2025荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2026',timelineData:[
              "2026荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]}
            ]
            // timelineData = jjList[3].timelineData  
            



            // var activeIndex = this.activeIndex;  
  
            // var middleIndexOffset = Math.floor((this.params.slidesPerView - 1) / 2); 
            // var middleIndex = (activeIndex + middleIndexOffset) % this.slides.length; // 考虑循环  
        
            // if (this.params.slidesPerView % 2 === 0) {  
            //   var isFirstInMiddleGroup = activeIndex % this.params.slidesPerView < this.params.slidesPerView / 2;  
            //   middleIndex = isFirstInMiddleGroup ? activeIndex : activeIndex - 1;  
            //   if (middleIndex < 0) {  
            //     middleIndex = this.slides.length + middleIndex;  
            //   }  
            // }  
            // console.log('当前中间幻灯片的索引是:', middleIndex); 


          },  
          slideChangeTransitionEnd: function () {  
            console.log('幻灯片更改动画结束！');  
          },  
        }, 
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      yearType:true
    };  
  }, 

  methods:{
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/aboutUs',res.data).banner[0]
      })
    },
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
    handleScroll() {
      const boxRect =  this.$refs.box.getBoundingClientRect();
      if (boxRect.top <= window.innerHeight && boxRect.bottom >= 0&& this.yearType) {
        this.yearType = false;
        // 当box进入视窗时触发动画
        this.startAnimation();
      }
    },
    startAnimation() {
      this.$refs.year.start();
      this.$refs.year2.start();
      this.$refs.year3.start();
      this.$refs.year4.start();
      this.$refs.ton.start();
      this.$refs.ton2.start();
      this.$refs.square.start();
      this.$refs.square2.start();
    }
  },
  mounted() {  
    window.addEventListener('scroll',this.handleScroll);
   
    this.$nextTick(()=>{
      this.cateEvent()
       let _index = 3
    this.timerId = setInterval(() => {
     
      this.timelineData = this.jjList[_index ++].timelineData
      if(_index+1 == this.jjList.length) {
        _index = 0
      }
    }, 2500);
      timeline().then((res)=>{
        // alert(JSON.stringify(res))
      })
    })
    
    // this.swiperInstance = new Swiper('.swiper-container', {  
    //   on: {  
    //     slideChange: () => {  
    //       console.log('当前活跃的 slide 索引:', this.swiperInstance.activeIndex);  
    //     },  
    //     click: (event) => {  
    //       alert("kkkk")
    //       const clickedIndex = this.swiperInstance.clickedIndex; // 获取被点击 slide 的索引（如果有多个slide被同时点击，取第一个）  
    //       console.log('点击的 slide 索引:', clickedIndex);  
    //       // 你可以根据点击的索引执行更多操作  
    //     }  
    //   }  
    // });  
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.timerId) {  
      clearInterval(this.timerId);  
      this.timerId = null;  
    } 
  }
}
</script>
<style lang="scss" scoped>
.wordsOne{
  font-weight: 200;
  position:absolute;
  right:140px;
  top:180px;
  z-index: 4;
  span {
    display: block;
    text-align: right;
    line-height: 40px;
    color: #272a36;
    letter-spacing: 1px;
  }
}
.company {
  // background: #fff url('./images/bgLogo01.png') no-repeat fixed center/cover padding-box content-box;
  position:relative;
  height: 320px;
}
.climeStyleBg {
  height:700px;
  width: 100%;
  background:  url('./images/clime.png') no-repeat top/cover padding-box content-box;
  background-size: 100% 100%;
  min-width: 1700px;
}
.climeStyle{
  // width: 100%;
  // background:  url('./images/clime.png') no-repeat top/cover padding-box content-box;
  // background-size: 100% 100%;
  .climeTitle{
    font-size:38px;
    font-weight: 700;
    text-align: center;
    display: block;
    margin:0 auto;
    letter-spacing: 1px;
  }

}
.logoContain{
  // text-align: center;
  position: relative;
  width: 25%;
  height: 100%;
  float:left;
  .logoTit{
    font-size:90px;
    color:#d32d25;
    display: block;
    letter-spacing: 1px;
    font-weight: 700;
    position:absolute;
    top:160px;
  }
  .logoWord {
    font-size: 20px;
    color:#272a36;
    display: block;
    position: absolute;
    bottom: 40px;
  }
}
.clearBoth {
  clear: both;
  line-height: 0;
  height: 0;
}

.words{
  line-height: 28px;
  span {
    display: block;
    font-size: 18px;
    color:#272a36;
    letter-spacing: 1px;
  }
}



.center-box {
  bottom:0;
      height: 130px;
      width: 100%;
      color: #FFFFFF;
      position: absolute;
      }
.card {
        //width: 250px;
        height: 130px;
        // background: #1B163F;
        // opacity: 0.3;
        display: flex;
        justify-content: space-around;
        align-items: center;
        color: #FFFFFF;
        font-size: 26px;
        }
::v-deep .swiper-button-next:after,
      .swiper-button-prev:after {
        display: none;
      }

      .arrow_left {
        width: 22px;
        height: 22px;
        transform: rotate(180deg);
        outline: none;
        border: 0;
        position: absolute;
        left: -40px;
      }

      .arrow_right {
        width: 22px;
        height: 22px;
        outline: none;
        border: 0;
        position: absolute;
        right: -40px;
      }



      .processBox {
      // background-color: #fff;
      // height: 210px;
    
      .title {
        font-size: 16px;
        font-weight: 600;
        padding-left: 32px;
        padding-top: 16px;
      }
      .timelineProcessBox {
        .timeline {
          display: flex;
          width: 95%;
          margin: 40px auto;
          .lineitem {
            transform: translateX(50%);
            width: 25%;
          }
        }
      }
    }
    
    :deep(.el-timeline-item__tail) {
      border-left: none;
      border-top: 2px solid #d32d25;
      width: 100%;
      position: absolute;
      top: 6px;
    }
    :deep(.el-timeline-item__wrapper) {
      padding-left: 0;
      position: absolute;
      top: 20px;
      transform: translateX(-50%);
      text-align: center;
    }
    :deep(.el-timeline-item__timestamp) {
      font-size: 14px;
      position: absolute;
      top:-70px;
      color:#272a36;
      font-size:24px;
      font-weight: 700;
      width:100%;
    }
    .active {
      :deep(.el-timeline-item__node) {
        background-color: #d32d25;
      }
      :deep(.el-timeline-item__tail) {
        border-color: #d32d25;
      }
    }
    有active样式的下一个li
    .active + li {
      :deep(.el-timeline-item__node) {
        background-color: #d32d25;
      }
    }

    ::v-deep .el-timeline-item__content {
      font-size: 18px;
    }

    ::v-deep .el-timeline-item__node {
      background-color: #d32d25;
    }
</style>
